import angular from 'angular';
import moment from 'moment';

(function () {
    'use strict';
    angular.module('app.core').factory('Document', DocumentData);

    function DocumentData() {
        Document.prototype = {
            build: build,
        };

        function Document(documentData) {
            if (documentData) {
                this.build(documentData);
            }
        }

        return Document;

        /////////////////////

        function build(documentData) {
            this.documentVersion = documentData.documentVersion;
            this.creationDate = moment(documentData.creationDate).format('DD/MM/YYYY');
            this.id = documentData.id;
            this.applicationDate = moment(documentData.applicationDate).format('DD/MM/YYYY');
        }
    }
})();
